import { render, staticRenderFns } from "./InfoLinkCard.vue?vue&type=template&id=b8a141a2&"
import script from "./InfoLinkCard.vue?vue&type=script&lang=js&"
export * from "./InfoLinkCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports